import { useEffect, useState} from 'react';
import * as Styles from '../styles';
import ApplicationsList from '../ApplicationsList/ApplicationsList';
import { withTab } from '../Tabs/withTab';
import moment from 'moment';

export const withStatusIndicator = (apps: any = []) => {
    return apps.map((app:any) => {
        if(app.newStatusStartDate && app.newStatusEndDate) {
          const sd = moment.utc(app.newStatusStartDate, 'dddd, MMMM DD, YYYY at h:mm:ss A Z');
          const ed = moment.utc(app.newStatusEndDate, 'dddd, MMMM DD, YYYY at h:mm:ss A Z');
          const now = moment.utc();
          if(now > sd && now < ed) {
            return { ...app, showNewIndicator: true }
          }
        }
        return { ...app, showNewIndicator: false};
      })
  }

export function ApplicationsTabInit({apps}:any) {
  const [applications, setApplications] = useState();
  
  useEffect(() => {
    if(apps) {
      setApplications(withStatusIndicator(apps));
    }
  }, [apps]);

  return (
    <Styles.ContentContainer>
      {applications && <ApplicationsList applications={applications} />}
    </Styles.ContentContainer>
  );
}

const ApplicationsTab =  withTab(ApplicationsTabInit);
export default ApplicationsTab;